import { Heart, TrendingUp, Rocket, Zap } from "lucide-react";
import chillHeroImage from "@/assets/chill-hero.png";

export const ChillExplainer = () => {
  return (
    <section className="relative flex items-center justify-center overflow-hidden gradient-cyan">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-30">
        <div className="absolute top-20 left-10 w-72 h-72 bg-cyan/20 rounded-full blur-[100px]" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-yellow/15 rounded-full blur-[120px]" />
      </div>

      {/* Content Overlay */}
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-24 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-10">
          {/* Main headline */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground leading-tight tracking-tight animate-fade-in">
            Wie zegt dat werk niet{" "}
            <span className="relative inline-block pb-1 isolate">
              <span className="relative z-10">chill</span>
              <span className="absolute -bottom-0.5 left-0 w-full h-2.5 md:h-3 bg-yellow -z-10"></span>
            </span>{" "}
            mag zijn?
          </h2>



          {/* 4 Pijlers - Subtle Horizontal Row */}
          <div className="flex flex-row justify-center items-center gap-8 md:gap-14 animate-fade-in" style={{ animationDelay: '200ms' }}>
            {/* Plezier */}
            <div className="group flex flex-col items-center gap-2 transition-transform duration-300 hover:scale-110">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-yellow flex items-center justify-center group-hover:shadow-[0_0_20px_rgba(250,204,21,0.6)] transition-all duration-300">
                <Heart className="w-6 h-6 md:w-7 md:h-7 text-foreground drop-shadow-lg" />
              </div>
              <span className="text-sm md:text-base font-heading font-bold text-foreground">Plezier</span>
            </div>

            {/* Groei */}
            <div className="group flex flex-col items-center gap-2 transition-transform duration-300 hover:scale-110">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-yellow flex items-center justify-center group-hover:shadow-[0_0_20px_rgba(250,204,21,0.6)] transition-all duration-300">
                <TrendingUp className="w-6 h-6 md:w-7 md:h-7 text-foreground drop-shadow-lg" />
              </div>
              <span className="text-sm md:text-base font-heading font-bold text-foreground">Groei</span>
            </div>

            {/* Ambitie */}
            <div className="group flex flex-col items-center gap-2 transition-transform duration-300 hover:scale-110">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-yellow flex items-center justify-center group-hover:shadow-[0_0_20px_rgba(250,204,21,0.6)] transition-all duration-300">
                <Rocket className="w-6 h-6 md:w-7 md:h-7 text-foreground drop-shadow-lg" />
              </div>
              <span className="text-sm md:text-base font-heading font-bold text-foreground">Ambitie</span>
            </div>

            {/* Energie */}
            <div className="group flex flex-col items-center gap-2 transition-transform duration-300 hover:scale-110">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-yellow flex items-center justify-center group-hover:shadow-[0_0_20px_rgba(250,204,21,0.6)] transition-all duration-300">
                <Zap className="w-6 h-6 md:w-7 md:h-7 text-foreground drop-shadow-lg" />
              </div>
              <span className="text-sm md:text-base font-heading font-bold text-foreground">Energie</span>
            </div>
          </div>

          {/* Tagline */}
          <p className="text-xl md:text-2xl font-heading font-black text-foreground animate-fade-in" style={{ animationDelay: '400ms' }}>
            Dat is chill.
          </p>


        </div>
      </div>
    </section>
  );
};
